var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcaseFilled = function SvgBriefcaseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14v1a1 1 0 0 0 2 0v-1h11v5a5.007 5.007 0 0 1-5 5H5a5.007 5.007 0 0 1-5-5v-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 0a5.01 5.01 0 0 1 4.9 4H19a5.007 5.007 0 0 1 5 5v3H0V9a5.007 5.007 0 0 1 5-5h1.1A5.01 5.01 0 0 1 11 0zm-2 2a3 3 0 0 0-2.816 2h7.632A3 3 0 0 0 13 2z",
    clipRule: "evenodd"
  })));
};
export default SvgBriefcaseFilled;